import { useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Security from './components/Security';
import Contact from './components/Contact';
import Footer from '../../components/feature/Footer';
import Navigation from '../../components/feature/Navigation';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      <Navigation />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <Security />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
